export const beaaAssistantGreeting =
  'Oi! Eu sou a Beaa, a mascote do bem-estar animal de Goiânia. Pode me perguntar sobre adoção, castração, UPAVET, animais desaparecidos, vacinação, guarda responsável e denúncias. Eu te ajudo por aqui.';

export const beaaAssistantKnowledge = [
  {
    id: 'saudacao',
    keywords: ['oi', 'ola', 'bom dia', 'boa tarde', 'boa noite', 'tudo bem', 'e ai', 'opa'],
    answer:
      'Oi! Que bom te ver por aqui. Eu sou a Beaa e posso te ajudar com adoção, castração, UPAVET, animais desaparecidos, vacinação e denúncias. Sobre o que você quer saber?',
    actions: [],
  },
  {
    id: 'adocao',
    keywords: [
      'adotar',
      'adocao',
      'quero adotar',
      'um lar',
      'cachorro para adotar',
      'gato para adotar',
      'adotar um animal',
      'adotado',
    ],
    answer:
      'Adotar é assumir uma vida! No Balcão de Adoção você encontra os animais resgatados que esperam por um lar, com foto, idade, porte e temperamento de cada um. É só escolher, conversar com a equipe e levar para casa com guarda responsável.',
    actions: [
      { label: 'Ver o Balcão de Adoção', icon: 'ri-home-heart-line', to: '/goiania/balcao-de-adocao' },
    ],
  },
  {
    id: 'castracao',
    keywords: [
      'castrar',
      'castracao',
      'esterilizacao',
      'esterilizar',
      'castracoes',
      'castracao gratuita',
    ],
    answer:
      'A castração é gratuita pelo programa municipal e ajuda a prevenir doenças e o abandono. No Castrômetro você acompanha quantas castrações já foram feitas, a evolução por período e como participar da próxima ação.',
    actions: [
      { label: 'Ver o Castrômetro', icon: 'ri-bar-chart-box-line', to: '/goiania/castrometro' },
    ],
  },
  {
    id: 'desaparecido',
    keywords: [
      'desaparec',
      'perdi',
      'perdido',
      'sumiu',
      'fugiu',
      'reencontr',
      'encontrei um animal',
      'achei um animal',
      'animal perdido',
    ],
    answer:
      'Se o seu animal desapareceu ou se você encontrou um, cadastre no Balcão de Desaparecidos. Lá ficam as fotos, a região e o contato, e dá para cruzar os cadastros de quem perdeu com quem achou. Quanto mais rápido registrar, maiores as chances de reencontro.',
    actions: [
      {
        label: 'Balcão de Desaparecidos',
        icon: 'ri-search-eye-line',
        to: '/goiania/balcao-de-desaparecidos',
      },
    ],
  },
  {
    id: 'upavet',
    keywords: ['upavet', 'veterinario', 'consulta', 'atendimento', 'clinica', 'vacina gratis'],
    answer:
      'A UPAVET é o atendimento veterinário público e gratuito do município. Ela faz consultas clínicas, vacinação e orientações de saúde para os animais da população. Na página da UPAVET você vê os serviços, a agenda e os indicadores de atendimento.',
    actions: [{ label: 'Conhecer a UPAVET', icon: 'ri-hospital-line', to: '/goiania/upavet' }],
  },
  {
    id: 'denuncia',
    keywords: [
      'denunci',
      'maus-tratos',
      'maus tratos',
      'crueldade',
      'abuso',
      'violencia',
      'maltrato',
    ],
    answer:
      'Maus-tratos são crime. O registro da denúncia é feito pela Polícia Civil e pela SEFIC. Você pode formalizar pela Delegacia Virtual (raivirtual.ssp.go.gov.br), pelo Disque Denúncia 197, pelo WhatsApp (62) 98581-8197 ou presencialmente na Rua J-38, Setor Jaó, ao lado do 26º DP. Junte fotos, vídeos e o máximo de informações do fato para ajudar na apuração. Em caso de risco imediato, acione a Polícia pelo 190.',
    actions: [
      {
        label: 'Delegacia Virtual',
        icon: 'ri-computer-line',
        href: 'https://raivirtual.ssp.go.gov.br/#',
      },
      { label: 'Canais de denúncia', icon: 'ri-alarm-warning-line', to: '/' },
    ],
  },
  {
    id: 'vacinacao',
    keywords: ['vacina', 'vacinacao', 'imunizar', 'vermifugo', 'vermifugar'],
    answer:
      'A vacinação protege contra doenças graves, como a raiva e a cinomose. Na UPAVET você acompanha as campanhas e os dias de vacinação gratuita. Mantenha a carteirinha do seu animal sempre em dia!',
    actions: [
      { label: 'Vacinação na UPAVET', icon: 'ri-first-aid-kit-line', to: '/goiania/upavet' },
    ],
  },
  {
    id: 'identificacao',
    keywords: [
      'microchip',
      'chip',
      'identificacao',
      'plaquinha',
      'coleira',
      'registrar o pet',
      'cadastrar meu pet',
    ],
    answer:
      'Identificar o seu animal é o jeito mais simples de garantir o reencontro se ele se perder. Use coleira com plaquinha de contato e, quando disponível, a microchipagem. O microchip é seguro e ajuda a localizar a família rapidinho.',
    actions: [
      {
        label: 'Falar no WhatsApp',
        icon: 'ri-whatsapp-line',
        href: 'https://wa.me/556230302811?text=Quero%20informa%C3%A7%C3%B5es%20sobre%20microchipagem',
      },
    ],
  },
  {
    id: 'guarda-responsavel',
    keywords: [
      'guarda responsavel',
      'cuidar',
      'cuidado',
      'cuidados',
      'como cuidar',
      'filhote',
      'responsabilidade',
    ],
    answer:
      'Guarda responsável é cuidar do animal por toda a vida: comida, água, abrigo, carinho, vacinação, higiene, segurança e atenção todos os dias. Pet não é brinquedo: é vida, cuidado e responsabilidade. Na seção Sobre a Beaa eu explico cada cuidado.',
    actions: [{ label: 'Sobre a Beaa', icon: 'ri-information-line', to: '/goiania/sobre-a-beaa' }],
  },
  {
    id: 'saude-publica',
    keywords: [
      'zoonose',
      'doenca',
      'saude publica',
      'raiva',
      'leishmaniose',
      'carrapato',
      'pulga',
    ],
    answer:
      'Cuidar dos animais é cuidar da saúde de todos. A castração, a vacinação e o controle de parasitas ajudam a prevenir zoonoses, que são doenças que passam dos animais para as pessoas. Os indicadores ficam no Castrômetro.',
    actions: [
      { label: 'Ver indicadores', icon: 'ri-bar-chart-box-line', to: '/goiania/castrometro' },
    ],
  },
  {
    id: 'dados',
    keywords: [
      'dados',
      'numero',
      'numeros',
      'estatistica',
      'transparencia',
      'quantas',
      'quantos',
      'indicadores',
    ],
    answer:
      'O portal é aberto para você acompanhar os números. Já passamos de 3.452 castrações gratuitas, mais de 2.847 animais adotados e 1.283 denúncias atendidas. No Castrômetro você vê a evolução completa.',
    actions: [
      { label: 'Ver os números', icon: 'ri-bar-chart-box-line', to: '/goiania/castrometro' },
    ],
  },
  {
    id: 'campanhas',
    keywords: ['campanha', 'evento', 'acao', 'feira', 'mutirao', 'vacinacao coletiva'],
    answer:
      'As campanhas de adoção, castração e guarda responsável acontecem ao longo do ano. Na página inicial do bem-estar animal você confere as próximas ações, as datas e como participar.',
    actions: [{ label: 'Ver campanhas', icon: 'ri-megaphone-line', to: '/' }],
  },
  {
    id: 'sobre-beaa',
    keywords: ['quem e voce', 'beaa', 'mascote', 'sobre voce', 'seu nome', 'quem e vc'],
    answer:
      'Eu sou a Beaa, a mascote do Bem Estar Animal da AMMA. Nasci das iniciais do programa para aproximar a causa animal do dia a dia das pessoas. Gosto de lembrar que animais bem, pessoas melhores, cidades mais felizes!',
    actions: [{ label: 'Minha história', icon: 'ri-award-line', to: '/goiania/sobre-a-beaa' }],
  },
  {
    id: 'contato',
    keywords: [
      'contato',
      'telefone',
      'whatsapp',
      'falar com alguem',
      'ligar',
      'email',
      'falar com uma pessoa',
    ],
    answer:
      'Se quiser falar com uma pessoa da equipe, o canal mais rápido é o WhatsApp. Por lá a equipe do bem-estar animal te responde com atenção.',
    actions: [
      {
        label: 'Falar no WhatsApp',
        icon: 'ri-whatsapp-line',
        href: 'https://wa.me/556230302811?text=Ol%C3%A1!%20Falei%20com%20a%20Beaa%20no%20portal.',
      },
    ],
  },
  {
    id: 'agradecimento',
    keywords: ['obrigad', 'valeu', 'brigad', 'agradeco', 'muito obrigado'],
    answer:
      'Fico feliz em ajudar! Se cuidar dos animais já é bom, imagina junto com você. Qualquer outra dúvida, é só chamar.',
    actions: [],
  },
  {
    id: 'caderneta-digital',
    keywords: [
      'caderneta',
      'caderneta digital',
      'carteirinha de vacina',
      'historico de vacina',
      'registrar vacina',
      'registrar a vacina',
      'saude do meu pet',
      'qr code',
    ],
    answer:
      'A Caderneta Digital PETBEA reúne o histórico de saúde do seu animal — vacinas, consultas, exames, medicamentos, vermifugação e castração — em um só lugar, com a origem de cada registro (tutor, profissional ou municipal). Você pode registrar uma vacina ou cuidado com foto do comprovante, acompanhar os lembretes das próximas doses e gerar um PDF para levar ao veterinário ou usar num processo de adoção.',
    actions: [
      { label: 'Abrir a Caderneta Digital', icon: 'ri-booklet-line', to: '/goiania/caderneta-digital' },
    ],
  },
  {
    id: 'minha-area',
    keywords: [
      'minha area',
      'minha conta',
      'meu cadastro',
      'como me cadastrar',
      'cadastrar no petbea',
      'cadastro no petbea',
      'me cadastro',
      'criar conta',
      'fazer login',
      'entrar na minha area',
      'area do cidadao',
      'meus animais',
      'meu pet',
    ],
    answer:
      'Na Minha Área PETBEA você reúne seus animais, a caderneta, adoções e serviços municipais. O cadastro é gratuito e leva poucos minutos: informe seus dados, confirme o CPF e cadastre seus pets. Quem já tem cadastro entra direto pelo e-mail ou pelo CPF.',
    actions: [
      { label: 'Criar minha Conta PETBEA', icon: 'ri-user-add-line', to: '/goiania/minha-area/cadastro' },
      { label: 'Entrar na Minha Área', icon: 'ri-login-circle-line', to: '/goiania/minha-area/entrar' },
    ],
  },
  {
    id: 'doar-adocao',
    keywords: [
      'doar',
      'doacao de animal',
      'quero doar',
      'tenho um animal para doar',
      'colocar para adocao',
      'disponibilizar para adocao',
      'ceder meu animal',
      'oferta de adocao',
    ],
    answer:
      'Se você tem um animal para doar, pode disponibilizá-lo para adoção pela Minha Área. Cadastre o animal com fotos, idade, porte e temperamento e acompanhe os interessados. A doação é sempre com guarda responsável: conversamos com quem quer adotar e explicamos os cuidados antes de passar o animal.',
    actions: [
      { label: 'Disponibilizar para adoção', icon: 'ri-heart-add-line', to: '/goiania/minha-area/adocao' },
    ],
  },
  {
    id: 'como-ajudar',
    keywords: [
      'quero ajudar',
      'ser voluntario',
      'voluntario',
      'sou protetor',
      'protetor independente',
      'cuidador comunitario',
      'ongs',
      'ong',
      'associacao',
      'faco parte de uma ong',
      'como participar',
    ],
    answer:
      'Você pode ajudar de várias formas: adotar, castrar, divulgar as campanhas ou se tornar Protetor Independente / Cuidador Comunitário e até representar uma ONG ou grupo de proteção. No cadastro você escolhe como quer participar do PETBEA e o Console valida cada perfil. Cadastrar-se é gratuito e fortalece toda a rede de proteção animal de Goiânia.',
    actions: [
      { label: 'Quero fazer parte', icon: 'ri-hand-heart-line', to: '/goiania/minha-area/cadastro' },
    ],
  },
];

export const beaaAssistantFallback = {
  id: 'fallback',
  keywords: [],
  answer:
    'Hmm, ainda estou aprendendo sobre isso. Mas posso te ajudar com adoção, castração, UPAVET, animais desaparecidos, vacinação, guarda responsável e denúncias. Toque em uma sugestão aqui embaixo ou me pergunte de outro jeito.',
  actions: [
    {
      label: 'Falar com uma pessoa',
      icon: 'ri-whatsapp-line',
      href: 'https://wa.me/556230302811?text=Ol%C3%A1!%20Tenho%20uma%20d%C3%BAvida%20sobre%20bem-estar%20animal.',
    },
  ],
};